import { Link } from "@tanstack/react-router"
import { Button } from "@/components/shared/buttons/button"

interface MessagePageProps {
	title: string
	description: string
}

export function MessagePage({ title, description }: MessagePageProps) {
	return (
		<div className="flex h-full w-full flex-col items-center justify-center gap-y-16 px-12">
			<h1 className="text-4xl text-primary">{title}</h1>
			<p className="max-w-xl text-center text-lg leading-normal">
				{description}
			</p>
			<Link to="/">
				<Button>Take me home</Button>
			</Link>
		</div>
	)
}
